import { Component, Input } from '@angular/core';
import { Grant } from '../../_models/grant';
import { Gender } from '../../_models/gender';

@Component({
  moduleId: module.id,
  selector: 'demographic',
  templateUrl: 'demographic.component.html',
  styleUrls: ['demographic.component.css']
})
export class DemographicComponent {
  @Input()
  public grant: Grant;
  public genders: Gender[] = [
        { "value": "Cisgender male", "text": "Cisgender male" },
        { "value": "Cisgender female", "text": "Cisgender female" },
        { "value": "Transgender male (FTM)", "text": "Transgender male (FTM)" },
        { "value": "Transgender female (MTF)", "text": "Transgender female (MTF)" },
        { "value": "Other", "text": "Other" }
    ];

  public setGender(genderValue: string){
      this.grant.gender = genderValue;
  }
}



// WEBPACK FOOTER //
// ./src/app/grant-form/demographic/demographic.component.ts